<template>
  <el-input
    v-if="!isPureNumber"
    :value="value"
    ref="kyeNumber"
    :step="currentStep"
    class="kye-number"
    :type="inputType"
    :clearable="clearable"
    onmousewheel="return false"
    onkeypress="return (/[\d|\-|+|.]/.test(String.fromCharCode(event.keyCode || event.which)))"
    :oninput="`if(value.length>${maxlength})value=value.slice(0,${maxlength})`"
    :disabled="disabled"
    :placeholder="disabled ? '' : placeholder"
    v-bind="$attrs"
    @focus="handleFocus"
    @blur="handleBlur"
    @change="handleChange"
  >
    <template v-if="symbol"
              slot="prepend">
      {{symbol}}
    </template>
    <template v-if="unit"
              slot="append">
      {{unit}}
    </template>
  </el-input>
  <el-input
    v-else
    :value="value"
    ref="kyeNumber"
    :step="currentStep"
    class="kye-number"
    type="text"
    :clearable="clearable"
    onmousewheel="return false"
    onbeforeinput="
      const nextVal = event.target.value.substring(0, event.target.selectionStart) +
      (event.data || '') + event.target.value.substring(event.target.selectionEnd);
      if(/^(-?)\d*(\.?)(\d+)?$/.test(nextVal)) {
        return
      }
      event.preventDefault()
    "
    onkeyup="this.value=this.value.replace(/\u3002/g, '.').replace(/\s+/g, '').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d*).*$/,'$1$2.$3').replace(/[A-Za-z]/g, '').replace(/[\u4e00-\u9fa5]/g, '');"
    :oninput="`if(value.length>${maxlength})value=value.slice(0,${maxlength})`"
    :disabled="disabled"
    :placeholder="disabled ? '' : placeholder"
    v-bind="$attrs"
    @focus="handleFocus"
    @blur="handleBlur"
    @change="handleChange"
  >
    <template v-if="symbol"
              slot="prepend">
      {{symbol}}
    </template>
    <template v-if="unit"
              slot="append">
      {{unit}}
    </template>
  </el-input>
</template>

<script>
  export default {
    name: 'kye-number',
    props: {
      value: [String, Number],
      symbol: String,
      unit: String,
      min: Number,
      max: Number,
      precision: Number,
      step: Number,
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请输入数字'
      },
      clearable: {
        type: Boolean,
        default: true
      },
      isPureNumber: {
        type: Boolean,
        default: false
      },
      bigInt: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      inputType () {
        const flag = String(this.value).indexOf('****') > -1 || String(this.value).indexOf('✽✽✽') > -1
        return flag ? 'text' : 'number'
      },
      maxlength () {
        return this.$attrs.maxlength || 15
      },
      currentStep () {
        let step = 1
        if (this.step) {
          step = this.step
        } else {
          if (this.precision) {
            step = '0.' + '0'.repeat(this.precision - 1) + '1'
          }
        }
        return step
      }
    },
    methods: {
      focus () {
        this.$refs.kyeNumber.focus()
      },
      handleChange (val) {
        let num = this.format(val)
        this.$emit('input', num)
        this.$emit('change', num)
      },
      handleBlur (e) {
        let val = e.target.value
        if (val === '') {
          this.handleChange('')
        }
        this.$emit('blur', e)
        // 2022-12-14 确保一定会触发，在isPureNumber的模式下 可能会出现输入法的问题造成 中文字 或英文 被带进去 Windows下
        if (this.isPureNumber) {
          let num = this.format(val)
          this.$emit('input', num)
        }
      },
      handleFocus (e) {
        this.$emit('focus', e)
      },
      format (val) {
        let num = ''
        if (val && !isNaN(Number(val))) {
          num = this.bigInt ? this.handleBigInt(val) : Number(val)
          if (this.max !== undefined && num >= this.max) {
            num = this.max
          }
          if (this.min !== undefined && num <= this.min) {
            num = this.min
          }
          if (this.precision !== undefined) {
            num = num.toFixed(this.precision)
          }
        }
        if (num === this.value) {
          this.$refs.kyeNumber.currentValue = num
        }
        if (num === '') {
          this.$refs.kyeNumber.currentValue = ' '
          this.$nextTick(_ => {
            this.$refs.kyeNumber && (this.$refs.kyeNumber.currentValue = num)
          })
        }
        return num
      },
      handleBigInt(val = 0) {
        // TODO 没有做BigInt方法兼容性判断
        return window.BigInt(val).toString()
      }
    }
  }
</script>

<style lang="scss">
  .kye-number {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    .el-input__inner {
      line-height: 12px;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-number/index.vue